export default (cognitoUser, name) => cognitoUser?.Attributes.find(({ Name }) => Name.toLowerCase() === name.toLowerCase())?.Value;
